import React, { useEffect, useState } from "react";
import { Container } from "./styles";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { MdAdd, MdDelete, MdEdit, MdHistory } from "react-icons/md";
import { Button, Input, Modal, Select, Spin } from "antd";
import { Card, HeaderTitle, Message, ViewInput } from "../../../GlobalStyles";
import { currencyConfig } from "../../../services/states";
import IntlCurrencyInput from "react-intl-currency-input";
import CountUp from "react-countup";
import { getValue } from "../../../services/functions";
import { ExclamationCircleFilled } from "@ant-design/icons";
const { confirm } = Modal;

export default function PacotesDeposito() {
  const [loading, setLoading] = useState(true);
  const [visibleModal, setVisibleModal] = useState(false);
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [packages, setPackages] = useState([]);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [type, setType] = useState("");
  const [value, setValue] = useState(0);
  const [bonus, setBonus] = useState(0);
  const [id, setId] = useState("");

  useEffect(() => {
    listPackages();
  }, []);

  async function listPackages() {
    await api
      .get(`/packages`)
      .then((response) => {
        setPackages(response.data);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  async function createAndEditPackage() {
    setIsLoadingModal(true);
    if (!name || !value) {
      toast.warn(
        "Nome e valor são obrigátorios para criar novo pacote de deposito",
      );
    } else {
      if (id) {
        await api
          .put(`/package/${id}`, {
            name,
            value,
            bonus,
            description,
            type,
          })
          .then(async (ok) => {
            toast.success("Pacote editado com sucesso");
            listPackages();
            setVisibleModal(false);
          })
          .catch(({ response }) => {
            if (response) {
              if (response.data) {
                if (response.data.message) {
                  toast.warn(response.data.message);
                } else {
                  toast.error(
                    "Erro Interno. verifique sua conexão e tente novamente",
                  );
                }
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente",
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          });
      } else {
        await api
          .post(`/package`, {
            name,
            value,
            bonus,
            description,
            type,
          })
          .then(async (ok) => {
            toast.success("Pacote criado com sucesso");
            listPackages();
            setVisibleModal(false);
          })
          .catch(({ response }) => {
            if (response) {
              if (response.data) {
                if (response.data.message) {
                  toast.warn(response.data.message);
                } else {
                  toast.error(
                    "Erro Interno. verifique sua conexão e tente novamente",
                  );
                }
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente",
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          });
      }
    }
    setIsLoadingModal(false);
  }

  async function deletePackage(id) {
    setIsLoadingModal(true);
    await api
      .delete(`/package/${id}`)
      .then(() => {
        toast.success("Pacote excluido com sucesso");
        listPackages();
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoadingModal(false);
  }

  return (
    <Container>
      <HeaderTitle>
        <h1>Pacotes de Deposito</h1>
        <div>
          <Button
            type="primary"
            style={{
              borderRadius: 50,
              marginRight: 20,
            }}
            onClick={() => {
              setId("");
              setName("");
              setValue("");
              setBonus("");
              setType("");
              setDescription("");
              setVisibleModal(true);
            }}
          >
            <MdAdd size="20" color="#fff" />
            Novo Pacote
          </Button>
        </div>
      </HeaderTitle>
      {loading ? (
        <Spin style={{ marginTop: 50 }} size="large" />
      ) : (
        <>
          <Card>
            <p>Total</p>
            <CountUp separator="." duration={1} end={packages.length} />
          </Card>
          {packages.length == 0 && <Message>Nenhum pacote encontrado</Message>}
          <div className="packages">
            {packages.map((item) => {
              return (
                <div className="package">
                  <p>
                    <strong>Nome:</strong> {item.name}
                  </p>
                  {item.description && (
                    <p>
                      <strong>Descriçao:</strong> {item.description}
                    </p>
                  )}
                  <p>
                    <strong>Tipo:</strong>{" "}
                    {item.type == "services" ? "Serviços" : "Leads"}
                  </p>
                  <p>
                    <strong>Valor:</strong> {getValue(item.value || 0)}
                  </p>
                  {!!item.bonus && (
                    <p>
                      <strong>Bônus:</strong> {getValue(item.bonus || 0)}
                    </p>
                  )}
                  <div>
                    <Button
                      className="warning-button"
                      onClick={() => {
                        setId(item.id);
                        setValue(item.value);
                        setName(item.name);
                        setDescription(item.description);
                        setType(item.type);
                        setBonus(item.bonus);
                        setVisibleModal(true);
                      }}
                    >
                      <MdEdit size={20} />
                      Editar
                    </Button>
                    <Button
                      className="delete-button"
                      onClick={() => {
                        confirm({
                          okText: "Confirmar",
                          title: "Deseja excluir o Pacote de Deposito?",
                          icon: <ExclamationCircleFilled />,
                          content: `Após essa ação, a pacote ${
                            item.name
                          } no valor de ${getValue(
                            item.value || 0,
                          )} será excluido`,
                          onOk() {
                            deletePackage(item.id);
                          },
                          onCancel() {},
                          cancelText: "Cancelar",
                        });
                      }}
                    >
                      <MdDelete size={20} />
                      Deletar
                    </Button>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}

      <Modal
        title={id ? "Editar Pacote" : "Novo Pacote"}
        width={500}
        confirmLoading={isLoadingModal}
        open={visibleModal}
        okText={"SALVAR"}
        cancelText="FECHAR"
        onOk={() => {
          createAndEditPackage();
        }}
        onCancel={() => {
          setVisibleModal(false);
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          <ViewInput>
            <p>Nome*</p>
            <Input
              placeholder="nome"
              value={name}
              onChange={(event) => setName(event.target.value)}
            />
          </ViewInput>
          <ViewInput style={{ width: "48%" }}>
            <p>Valor do Deposito</p>
            <IntlCurrencyInput
              style={{
                width: "100%",
                backgroundColor: "#FFF",
                borderWidth: 0,
                color: "#000",
                padding: "6px 8px",
                fontSize: 14,
                borderWidth: 1,
                borderColor: "#ccc",
                borderStyle: "solid",
                borderRadius: 2,
                fontWeight: "400",
                paddingLeft: 12,
              }}
              currency="BRL"
              config={currencyConfig}
              value={value}
              onChange={(event, value) => setValue(value)}
            />
          </ViewInput>

          <ViewInput style={{ width: "48%" }}>
            <p>Bônus do Deposito</p>
            <IntlCurrencyInput
              style={{
                width: "100%",
                backgroundColor: "#FFF",
                borderWidth: 0,
                color: "#000",
                padding: "6px 8px",
                fontSize: 14,
                borderWidth: 1,
                borderColor: "#ccc",
                borderStyle: "solid",
                borderRadius: 2,
                fontWeight: "400",
                paddingLeft: 12,
              }}
              currency="BRL"
              config={currencyConfig}
              value={bonus}
              onChange={(event, value) => setBonus(value)}
            />
          </ViewInput>
          <ViewInput>
            <p>Tipo de Pacote*</p>
            <Select
              style={{
                width: "100%",
              }}
              placeholder="selecione o tipo"
              value={type || null}
              onChange={(value) => setType(value)}
            >
              <Select.Option value="services">Serviços</Select.Option>
              <Select.Option value="leads">Leads</Select.Option>
            </Select>
          </ViewInput>
          <ViewInput>
            <p>Descrição*</p>
            <Input.TextArea
              style={{
                minHeight: 50,
              }}
              placeholder="descrição"
              value={description}
              onChange={(event) => setDescription(event.target.value)}
            />
          </ViewInput>
        </div>
      </Modal>
    </Container>
  );
}
